/* eslint-disable import/no-named-as-default */
"use client";

import { Vehicle } from "@alba-cars/common-modules";
import { useTranslations } from "next-intl";

import TestDriveButton from "./TestDriveButton";
import Button from "@/components/ui/buttons/Button";
import { slugify } from "@/lib/utils";

const CarNavigationButton = ({ isMainCar, car }: { isMainCar: boolean; car: Vehicle }) => {
  const t = useTranslations("CarDetails");

  const trim = car?.trim ?? "";
  const refId = car?.refId ?? "";
  const make = car?.make?.name ?? "";
  const model = car?.model?.name ?? "";

  return isMainCar ? (
    <TestDriveButton
      car={car}
      className="w-full py-3 text-center transition-all duration-300 ease-in-out hover:bg-primary-dark disabled:cursor-not-allowed disabled:opacity-50"
    />
  ) : (
    <Button
      buttonText={isMainCar ? t("testDrive.bookTestDrive") : t("navigation.viewCarDetails")}
      bgColor={isMainCar ? "primary" : "primary-light"}
      textColor={isMainCar ? "white" : "primary"}
      className="w-full py-3 text-center transition-all duration-300 hover:bg-primary hover:text-white"
      onClick={() => {
        const routeTo = trim
          ? `/buy-used-cars/vehicle/${refId}-${slugify(make)}-${slugify(model)}-${slugify(trim)}`
          : `/buy-used-cars/vehicle/${refId}-${slugify(make)}-${slugify(model)}`;
        window.location.href = routeTo;
      }}
    />
  );
};

export default CarNavigationButton;
